<div class="container" [class.sat]="isWeekDay(date, 6)" [class.sun]="isWeekDay(date, 0)">
  <div class="title">{{ date | date: "EE" }}</div>
  <div class="body">{{ date | date: "dd" }}</div>
</div>
<!-- <div class="title">{{ date | date: "EE" }}</div>
<div class="body">{{ date | date: "dd" }}</div> -->
